__turbopack_context__.v({
  "SArticle": "okKurW_SArticle",
  "SPosterHeader": "okKurW_SPosterHeader",
  "SPosterWrapper": "okKurW_SPosterWrapper",
  "SScoreData": "okKurW_SScoreData",
  "row-layout": "okKurW_row-layout",
});
